import type { QueryClient } from '@tanstack/react-query';
import { mparticleIntegrationKeys, type MParticleIntegration } from './entity';

/**
 * Imperative cache ops for the mParticle connector record.
 *
 * The detail slot is the only place this record lives — the integrations
 * directory and the connections overview read it through the same key — so a
 * save or a disconnect here is what refreshes their "connected" state, the way
 * mutating the Ember record updated the catalog row it was loaded from.
 */

const detailKey = (workspaceId: number) => mparticleIntegrationKeys.detail(workspaceId, 'mparticle');

export function setMParticleIntegrationCache(
  qc: QueryClient,
  workspaceId: number,
  integration: MParticleIntegration,
): void {
  qc.setQueryData(detailKey(workspaceId), integration);
}

/**
 * A disconnected connector is "connected: no", which is `null` — not an absent
 * slot. Writing `null` keeps the config page and the directory on the same
 * answer without a refetch; removing the slot would leave observers refetching
 * a record that is gone.
 */
export function clearMParticleIntegrationCache(qc: QueryClient, workspaceId: number): void {
  qc.setQueryData(detailKey(workspaceId), null);
}
